import axios from "axios";
import getEndpoint from "../getEndpoint";

const ngrokSkipWarning = {headers: {"bypass-tunnel-reminder": "true"} };

export async function UpdatePayment(credentials: any){
    const response = await axios.put(`${getEndpoint()}/api/Payment/Update`, credentials, ngrokSkipWarning);
    //console.log(response.data);
    return response.data;
}

export async function DeletePayment(id:any) {
    const response = await axios.delete(`${getEndpoint()}/api/Payment/Delete?id=${id}`, {
        ...ngrokSkipWarning
    });
    return response.data;
}
